<template>
  <div>
    <!-- 售后 -->
    <baseBreadcrumb :page="`${$t('message.afterSale')}`" :menu="$t('message.money')"></baseBreadcrumb>
    <div class="body">
      <div class="tabs">
        <el-tabs v-model="datas.status" type="card" @tab-click="search">
          <el-tab-pane :label="$t('message.all')" name=""></el-tab-pane>
          <!-- 待确认 -->
          <el-tab-pane :label="$t('message.toBeConfirmed')" name="1">
          </el-tab-pane>
          <!-- 已确认 -->
          <el-tab-pane :label="$t('message.confirmed')" name="2">
          </el-tab-pane>
          <!-- 已删除 -->
          <el-tab-pane :label="$t('message.deleted')" name="-1">
          </el-tab-pane>
        </el-tabs>
      </div>
      <!-- 搜索 -->
      <div class="search">
        <div class="row">
          <div class="item">
            <el-date-picker v-model="datas.confirmDateStart" :placeholder="$t('message.startDate')" type="datetime"
              default-time="['00:00:00']" value-format="yyyy-MM-dd HH:mm:ss" style="width: 200px">
            </el-date-picker>
          </div>
          <!--  结束日期-->
          <div class="item">
            <el-date-picker v-model="datas.confirmDateEnd" :placeholder="$t('message.dateClosed')"
              default-time="['23:59:59']" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width: 200px">
            </el-date-picker>
          </div>
          <!--  赔款单号-->
          <div class="item">
            <el-input v-model="datas.reparation_sn" :placeholder="$t('message.claimNumber')" onfocus="this.select()" />
          </div>
          <!--  订单号-->
          <div class="item">
            <el-input v-model="datas.order_sn" :placeholder="$t('message.orderNumber')" onfocus="this.select()" />
          </div>
          <!--  配送单号-->
          <div class="item">
            <el-input v-model="datas.porder_sn" :placeholder="$t('message.porderNumber')" onfocus="this.select()" />
          </div>
          <!--责任主体类型-->
          <div class="item">
            <el-select v-model="datas.liable_type" :placeholder="$t('message.pleaseSelectTheType')" filterable clearable
              @change="selectTheType">
              <el-option :label="$t('message.companyEmployee')" :value="1">
              </el-option>
              <el-option :label="$t('message.externalLogisticsCompany')" :value="2">
              </el-option>
              <el-option :label="$t('message.thirdPartySeller')" :value="3">
              </el-option>
            </el-select>
          </div>
          <!--  责任人-->
          <div class="item" v-if="datas.liable_type == 1">
            <el-select v-model="datas.uids" :placeholder="$t('message.companyEmployee')" filterable
              @change="$forceUpdate();">
              <el-option v-for="item in adminList" :key="item.id" :label="item.realname" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <!--  物流公司-->
          <div class="item" v-else-if="datas.liable_type == 2">
            <el-select filterable v-model="wuliuName" :placeholder="$t('message.pleaseEnterTheLogisticsNumber')">
              <el-option v-for="item in logisticsList" :label="item.name" :value="item.name" :key="item.id">
              </el-option>
            </el-select>
          </div>
          <!--  第三方卖家-->
          <div class="item" v-else-if="datas.liable_type == 3">
            <el-input v-model="thirdParty" :placeholder="$t('message.thirdPartySeller')" onfocus="this.select()" />
          </div>
          <!--  请选则类型-->
          <div class="item" v-else>
            <el-input v-model="thirdParty" :placeholder="$t('message.pleaseSelectTheType')" onfocus="this.select()"
              disabled />
          </div>
        </div>
        <div class="row">
          <!--  人员范围-->
          <div class="item">
            <cascader :org_id="datas.org_id" ref="cascader" @setUserList="setUserList" />
          </div>
          <!--工种-->
          <div class="item"><el-select v-model="datas.work_type" :placeholder="$t('message.typeOfWork')">
              <el-option v-for="item in worktypeData" :key="item.id" :label="item.work_name" :value="item.id">
              </el-option>
            </el-select></div>
          <!--  责任人-->
          <div class="item">
            <el-input v-model="datas.realnames" :placeholder="$t('message.responsiblePerson')"
              onfocus="this.select()" />
          </div>
          <!--  客户名/ID-->
          <div class="item">
            <el-input v-model="datas.user_id" :placeholder="$t('message.clientID')" onfocus="this.select()" />
          </div>
          <!--  客户名/ID-->
          <div class="item">
            <el-input v-model="datas.client_realname" :placeholder="$t('message.userName')" onfocus="this.select()" />
          </div>
          <!-- 搜索 -->
          <el-button type="primary" @click="search">
            {{ $t("message.search") }}
          </el-button>
          <!-- 重置 -->
          <el-button @click="reset">
            {{ $t("message.reset") }}
          </el-button>
          <!-- 操作 -->
          <div class="operation">
            <!--新建配送单赔款-->
            <el-button type="success" @click="deliveryOrderCompensation" v-if="isAuth(346)">
              {{ $t("message.newDeliveryOrderCompensation") }}
            </el-button>
            <!--新建订单赔款-->
            <el-button type="success" @click="$refs.orderList.dialogVisible = true" v-if="isAuth(346)">
              {{ $t("message.newOrderCompensation") }}
            </el-button>
          </div>
        </div>
      </div>
      <!-- 列表 -->
      <div class="table">
        <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
          :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%" :height="tableautoheight">
          <!-- NO -->
          <el-table-column align="center" label="NO" type="index" width="60">
          </el-table-column>
          <!-- 关联赔款 -->
          <el-table-column align="center" :label="$t('message.claimNumber')" width="180">
            <template slot-scope="scope">
              <a href="javascript:;" class="a-link" v-if="scope.row.aftersale_sn_set == false" @click="edit(scope.row)">
                {{ scope.row.reparation_sn }}
              </a>
              <span v-else>
                <p v-for="(item, index) in scope.row.aftersale_sn_set" :key="index">
                  <router-link :to="'/wholeOrderAfterSale?after_sale_sn=' + item.after_sale_sn" class="a-link"
                    target="_blank" v-if="item.is_whole_porder == 1">
                    {{ scope.row.reparation_sn }}</router-link>
                  <router-link
                    :to="'/afterSaleOfGoods?after_sale_sn=' + item.after_sale_sn + '&reparation_sn=' + scope.row.reparation_sn"
                    class="a-link" target="_blank" v-else>
                    {{ scope.row.reparation_sn }}</router-link>
                </p>
              </span>
            </template>
          </el-table-column>
          <!-- 售后号 -->
          <el-table-column align="center" :label="$t('message.afterSalesOrderNumber')" width="180">
            <template slot-scope="scope">
              <p v-for="(item, index) in scope.row.aftersale_sn_set" :key="index">
                <router-link :to="'/wholeOrderAfterSale?after_sale_sn=' + item.after_sale_sn" class="a-link"
                  target="_blank" v-if="item.is_whole_porder == 1">
                  {{ item.after_sale_sn }}</router-link>
                <router-link :to="'/afterSaleOfGoods?after_sale_sn=' + item.after_sale_sn" class="a-link"
                  target="_blank" v-else>
                  {{ item.after_sale_sn }}</router-link>
              </p>
            </template>
          </el-table-column>
          <!-- 提出人 -->
          <el-table-column align="center" :label="$t('message.peoplePutForward')" prop="created_by_name" width="100">
          </el-table-column>
          <!-- 确认人 -->
          <el-table-column align="center" :label="$t('message.affirmName')" width="100" prop="confirm_by_name">
          </el-table-column>
          <!-- 配送单号 -->
          <el-table-column align="center" :label="$t('message.orderDistribution')" width="200">
            <template slot-scope="scope">
              <p v-for="(item, index) in scope.row.porder_sn_set" :key="index">
                <router-link :to="'/porderDetail?porder_sn=' + item" class="a-link" target="_blank">
                  {{ item }}
                </router-link>
              </p>
              <p v-for="(item, index) in scope.row.order_sn_set" :key="index">
                <router-link :to="'/orderDetail?order_sn=' + item" class="a-link" target="_blank">
                  {{ item }}
                </router-link>
              </p>
            </template>
          </el-table-column>
          <!-- 客户 -->
          <el-table-column align="center" :label="$t('message.user')">
            <template slot-scope="scope">
              {{ scope.row.user.realname }}
              <attributeName :name="scope.row.user.attribute_name" v-if="scope.row.user.attribute_name" />
            </template>
          </el-table-column>
          <!-- 赔款原因 -->
          <el-table-column align="center" :label="$t('message.reasonForCompensation')" prop="reason">
          </el-table-column>
          <!-- 责任人 -->
          <el-table-column align="center" :label="$t('message.responsiblePerson')" width="180">
            <template slot-scope="scope">
              <p v-for="(item, index) in scope.row.reparation_amount" :key="index">
                {{ index == 0 ? '主' : '次' }}:{{ item.main_admin ? item.main_admin : item.main }} : {{
                  item.amount }}元
              </p>
            </template>
          </el-table-column>
          <!-- 处理时间 -->
          <el-table-column align="center" :label="$t('message.ChuliTime')" width="200">
            <template slot-scope="scope">
              <p>提出：{{ scope.row.created_at }}</p>
              <p>确认：{{ scope.row.confirm_at }}</p>
            </template>
          </el-table-column>
          <!-- 合计赔款.元 -->
          <el-table-column align="center" :label="$t('message.totalIndemnityYuan')" prop="total" width="100">
          </el-table-column>
          <!-- 状态 -->
          <el-table-column align="center" :label="$t('message.status')" prop="status_name" width="100">
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 订单预览选择赔款 -->
    <orderList ref="orderList" />
    <!-- 赔款 -->
    <claimIndemnity :indemnityList="list" ref="claimIndemnity" :reparation_sn="reparation_sn" :type="type" />
    <!-- 赔款 -->
    <porderClaimIndemnity ref="porderClaimIndemnity" :reparation_sn="reparation_sn" :type="type" />
    <!-- 售中赔款 -->
    <inSaleClaimIndemnity ref="inSaleClaimIndemnity" :reparation_sn="reparation_sn" :type="type" />
  </div>
</template>
<script>
import { indemnityStatus, afterSaleCategory } from "@/utlis/options";
import orderList from './components/orderList'
import claimIndemnity from './components/claimIndemnity'
import porderClaimIndemnity from './components/porderClaimIndemnity'
import inSaleClaimIndemnity from './components/inSaleClaimIndemnity'
import { mapState } from 'vuex'
export default {
  components: {
    orderList,
    claimIndemnity,
    porderClaimIndemnity,
    inSaleClaimIndemnity
  },
  data() {
    return {
      tableautoheight: window.innerHeight > 500 ? window.innerHeight - 200 : 800,
      indemnityStatus,
      afterSaleCategory,
      userList: [],
      datas: {
        status: "1",
        page: 1,
        pageSize: 10,
        org_id: "",
        realnames: '',
        liable_type: '',
        confirmDateStart:'',
        confirmDateEnd:'',
      },
      total: 0,
      tableData: [],
      list: [], //商品数据
      reparation_sn: '', //赔款单号
      type: '',
      wuliuName: '', // 物流筛选
      thirdParty: '',// 第三方卖家
      adminList: [],//赔款人列表
      worktypeData: [],//工种
    };
  },
  computed: {
    ...mapState({
      logisticsList: (state) => state.porderDetail.logisticsList,
    }),
  },
  created() {
    this.$store.dispatch("getLogisticsList"); //物流方式获取
    // 获取赔款人
    this.$api.roleApi.accountNumberList({ pageSize: 99999, forSelect: 1 }).then(res => {
      this.adminList = res.data.data
    })
    if (this.$route.query.status) {
      this.datas.status = this.$route.query.status
    }
    if (this.$route.query.reparation_sn) {
      this.datas.status = ''
      this.datas.reparation_sn = this.$route.query.reparation_sn
    }
    if (this.$route.query.liable_content) {
      const date = new Date()
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const lastDay = new Date(year, date.getMonth() + 1, 0).getDate()
      const japanUserRoleInfo = JSON.parse(localStorage.getItem('japanUserRoleInfo'))
      this.datas.confirmDateStart = `${year}-${month}-01 00:00:00`
      this.datas.confirmDateEnd = `${year}-${month}-${lastDay} 23:59:59`
      this.datas.realnames = japanUserRoleInfo.realname
    }
    this.reparationList();
    // 工种
    this.$api.roleApi.worktypeList().then((res) => {
      this.worktypeData = res.data;
    });
  },
  methods: {
    reparationList() {
      this.$api.capitalApi.reparationList(this.datas).then((res) => {
        this.tableData = res.data.data;
        this.tableData.forEach(item => {
          item.total = 0
          item.reparation_amount.forEach(items => {
            item.total += items.amount - 0
          })
          item.total = item.total.toFixed(2)
        })
        this.total = res.data.total;
      });
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.reparationList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.reparationList();
    },
    search() {
      this.datas.page = 1;
      if (this.datas.liable_type == 2) {
        this.datas.liable_content = this.wuliuName
      } else if (this.datas.liable_type == 3) {
        this.datas.liable_content = this.thirdParty
      }
      this.reparationList();
    },
    reset() {
      this.datas = {
        status: "",
        liable_type: '',
        page: 1,
        pageSize: 10,
        org_id: "",
        uids: '',
        work_type: '',
        realnames: '',
        user_id: '',
        client_realname: '',
      };
      this.$refs.cascader.orgId = [];
      this.reparationList();
    },
    // 人员范围
    setUserList(data) {
      this.userList = data.userList;
      this.datas.org_id = data.id;
      this.datas.realnames = ''
    },
    //赔款单-获取新赔款单号
    getNewReparationSn() {
      this.$api.capitalApi.getNewReparationSn().then(res => {
        this.reparation_sn = res.data
        this.$refs.claimIndemnity.addIndemnity()
      })
    },
    // 打开赔款
    claimIndemnity(list) {
      this.list = list
      this.type = '未提出'
      this.getNewReparationSn()
    },
    // 新建配送单赔款
    deliveryOrderCompensation() {
      this.list = []
      this.type = '未提出'
      this.$api.capitalApi.getNewReparationSn().then(res => {
        this.reparation_sn = res.data
        this.$refs.porderClaimIndemnity.addIndemnity()
      })
    },
    //修改
    edit(item) {
      let itemData = JSON.parse(JSON.stringify(item))
      this.list = []
      this.type = itemData.status_name
      this.reparation_sn = itemData.reparation_sn
      if (item.order_sn_set != false) {
        itemData.reparation_detail.forEach(items => {
          let data = items.order_detail
          data.amount = items.amount
          this.list.push(data)
        })
        this.$nextTick(() => {
          this.$refs.claimIndemnity.editIndemnity(itemData)
        })
      } else if (item.porder_sn_set != false) {
        this.$nextTick(() => {
          this.$refs.porderClaimIndemnity.editIndemnity(itemData)
        })
      } else {
        //售中和抽查赔款用同一个
        this.$nextTick(() => {
          this.$refs.inSaleClaimIndemnity
            .editIndemnity(itemData)
        })
      }
    },
    // 赔款类型
    selectTheType() {
      this.wuliuName = ''// 物流筛选
      this.thirdParty = ''// 第三方卖家
      this.datas.uids = ''
    }
  },
};
</script>
<style lang='scss' scoped>
.search {
  margin: 20px 0;

  .row {
    display: flex;
    margin-bottom: 20px;
    position: relative;

    .item {
      margin-right: 20px;
      width: 200px;
    }

    .operation {
      position: absolute;
      right: 0;
      top: 0;
    }
  }
}
</style>
